import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay, Pagination } from "swiper/modules";
import { websiteConfigurationEnum } from "../../../enums/websiteConfigurations/websiteConfiguration.enum";
import useWebsiteConfiguration from "../../../hooks/websiteConfigurations/useWebsiteConfiguration";
import HomeBannerCardComponent from "./HomeBanenrCardComponent";
import "../../../styles/components/home/banners/homeBannerListComponent.scss";

export const HomeBannerListComponent = () => {
  const { configurationValue: banners } = useWebsiteConfiguration(websiteConfigurationEnum.HomeBanner);

  // Ensure banners is an array
  const bannerList = Array.isArray(banners) ? banners : [];

  return (
    <div className="noPadding homePageBannerContainer ">
      <Swiper
        className="swiperContainer"
        pagination={{ clickable: true }}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        modules={[Pagination, Autoplay]}>
        {bannerList.map((banner) => (
          <SwiperSlide key={banner.Id}>
            <HomeBannerCardComponent props={{ image: banner.Url }} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default HomeBannerListComponent;
